import disputeActionConstants from '../constants/disputeActionConstants';

const initialState = {
  disputes: [],
  disputesLoading: false,
  pageInfo: null,
  disputeFilters: {},
  disputeDetails: {},
};

const disputesReducer = (state = initialState, action) => {
  switch (action.type) {
    case disputeActionConstants.GET_DISPUTES:
      return {
        ...state,
        disputes: [],
        pageInfo: null,
        disputesLoading: true,
      };
    case disputeActionConstants.GET_DISPUTES_SUCCESS:
      return {
        ...state,
        disputes: action.payload.disputes,
        pageInfo: action.payload.page_info,
        disputesLoading: false,
      };
    case disputeActionConstants.GET_DISPUTES_ERROR:
      return {
        ...state,
        disputesLoading: false,
      };
    case disputeActionConstants.GET_DISPUTE_DETAILS:
      return {
        ...state,
        disputeDetails: action.payload || {},
      };
    case disputeActionConstants.GET_DISPUTE_FILTERS_DATA:
      return {
        ...state,
        disputeFilters: action.payload,
      };
    case disputeActionConstants.MARK_DISPUTE_CLOSE:
      return {
        ...state,
        disputes: state.disputes.map((dispute) => {
          if (dispute.id === action.payload) {
            return {
              ...dispute,
              open: false,
            };
          }
          return dispute;
        }),
      };
    case disputeActionConstants.MARK_DISPUTE_OPEN:
      return {
        ...state,
        disputes: state.disputes.map((dispute) => {
          if (dispute.id === action.payload) {
            return {
              ...dispute,
              request_to_close: false,
            };
          }
          return dispute;
        }),
      };
    default:
      return {
        ...state,
      };
  }
};

export default disputesReducer;
